export const WireAmountHelperTestIds = {
  REVERT_BUTTON: 'wire-amount.revert-button',
};
